// Shared by the thread list (screens/threads) and thread detail
// (screens/thread-detail) -- the second call site is why this moved
// out of screens/threads/index.tsx rather than being copy-pasted a
// second time there, same precedent as MIN_PASSWORD_LENGTH in
// lib/password.ts. Still a one-line formatting rule, not branching
// logic worth its own hook/test -- same reasoning as the profile
// screen's radiusHelperText, so no dedicated test file either.
export function relativeTime(iso: string): string {
  const diffMin = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60_000));
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.round(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h ago`;
  const diffDay = Math.round(diffHr / 24);
  if (diffDay < 7) return `${diffDay}d ago`;
  return `${Math.round(diffDay / 7)}w ago`;
}
